/** Wettkampfergebnisse und offizielle Bestzeiten (ADR 0012). */
export default {
  card: {
    title: 'Wettkämpfe & Bestzeiten',
    sub: 'Offizielle Nettozeit, wo eingetragen – „~" = Gesamtzeit der Uhr inkl. Pausen. Nur bestätigte Wettkämpfe zählen. Rahmen = neu in {year}',
    add: 'Ergebnis eintragen',
    bests: 'Bestzeiten',
    repeats: 'Je Rennen',
    noBests: 'Noch keine Bestzeit. Markiere Läufe als „Wettkampf" oder trag ein Ergebnis ein.',
    list: 'Alle Wettkämpfe',
    freshSr: 'neu in {year}',
    listCount: { one: '{count} Wettkampf', other: '{count} Wettkämpfe' },
    showAll: 'Alle {count} zeigen',
    showLess: 'Weniger zeigen',
    starts: { one: '{count} Start', other: '{count} Starts' },
    loadError: 'Wettkämpfe nicht verfügbar: {error}',
    suggestions: { one: '{count} Lauf klingt nach Wettkampf', other: '{count} Läufe klingen nach Wettkampf' },
    suggestionsHint: 'Erkannt am Titel, zählt erst nach Bestätigung. Am Lauf unter „Markierungen" auf „Wettkampf" tippen.',
  },
  state: {
    suggested: 'Distanz vorgeschlagen',
    missing: 'Distanz fehlt',
    watch: 'Gesamtzeit der Uhr',
    fromTitle: 'Distanz aus dem Titel',
    fromMeasured: 'Distanz aus der Messung',
    manual: 'ohne Aufzeichnung',
    timeMissing: 'Zeit fehlt',
    snapped: 'gemessen {measured}, als {official} vorgeschlagen',
    approx: 'ungefähr, aus der Uhr: ',
    dnfAfter: 'aufgegeben nach {time}',
    dnfAfterWatch: 'aufgegeben nach {time} (Uhr gesamt)',
    pbDistance: 'neue Bestzeit {distance}',
    pbRace: 'neue Bestzeit im Rennen',
    watchCompare: 'Uhr gesamt {time}',
    dnf: 'abgebrochen',
  },
  form: {
    addTitle: 'Ergebnis eintragen',
    editTitle: 'Ergebnis bearbeiten',
    blockTitle: 'Wettkampf',
    name: 'Rennen',
    namePlaceholder: 'z. B. Silvesterlauf',
    date: 'Datum',
    distance: 'Offizielle Distanz',
    other: 'Andere Distanz',
    otherKm: 'km',
    none: 'unbekannt',
    time: 'Nettozeit',
    timePlaceholder: 'h:mm:ss',
    timeHint: 'Leer = Gesamtzeit der Uhr inkl. Pausen ({watch})',
    timeFormat: 'Format h:mm:ss, auch 2.07.00',
    nameHint: 'Leer = {name}',
    distanceRule: 'Vorschlag aus dem Titel oder aus der Messung, wenn sie bis 3 % neben 5 km, 10 km, Halbmarathon oder Marathon liegt. Bestzeit über eine Standarddistanz zählt bis 0,5 % daneben.',
    suggestedOption: '{name} (vorgeschlagen)',
    saveNext: 'Speichern & nächstes',
    saved: 'Gespeichert: {name}',
    timeError: 'Zeit als h:mm:ss oder mm:ss eingeben',
    distanceError: 'Distanz in km eingeben',
    nameError: 'Name des Rennens fehlt',
    dnf: 'Abgebrochen',
    reset: 'Eingaben zurücksetzen',
    resetConfirm: 'Eigene Eingaben zu diesem Wettkampf löschen? Dann gelten wieder die Vorschläge.',
    deleteConfirm: 'Dieses eingetragene Ergebnis löschen?',
    measured: 'gemessen {km}',
    notSaved: 'Nicht gespeichert: {error}',
  },
  distances: { '5k': '5 km', '10k': '10 km', half: 'Halbmarathon', marathon: 'Marathon' },
  today: {
    title: { one: 'Neue Bestzeit', other: '{count} neue Bestzeiten' },
    item: '{label}: {time} · {name}, {date}',
    itemRace: '{name}: {time} im Rennen · {date}',
    watch: '~',
  },
};
